import styled from "@emotion/styled";
import { Accordion, ButtonBase } from "@mui/material";
import { Link, NavLink } from "react-router-dom";

export const Section = styled('main')(({ theme }) => (props) => ({
    display: 'flex',
    padding: '48px 96px',
    [theme.breakpoints.down('md')]: {
        padding: '24px 48px',
        flexDirection: 'column'
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px  6px ',
    },
    [theme.breakpoints.down('xs')]: {
        padding: '12px 6px',
    },
}))

export const LeftSection = styled('div')(({ theme }) => (props) => ({
    width: '21%',
    [theme.breakpoints.down('lg')]: {
        width: '30%'
    },
    [theme.breakpoints.down('md')]: {
        width: '90%'
    },
}))

export const RightSection = styled('div')(({ theme }) => (props) => ({
    flex: 1,
    borderLeft: '1px solid #BDBDBD ',
    paddingLeft: '10px',
}))

export const DetailsCourse = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    justifyContent: 'center'
}
))

export const DetailsTitle = styled('h4')(({ theme }) => (props) => ({
    fontSize: '24px',
    fontWeight: 800,
    lineHeight: '29px',
    margin: '0',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary
}))

export const ImageSection = styled('div')(({ theme }) => (props) => ({
    width: '144px',
    height: '144px',
}))

export const Image = styled('img')(({ theme }) => (props) => ({
    width: '100%',
    height: '100%',
    borderRadius: theme.shape.borderRadius
}))

export const TextDiscretion = styled('p')(({ theme }) => (props) => ({
    fontSize: '1vw',
    fontWeight: '400',
    lineHeight: '1.2vw',
    letterSpacing: '0em',
    display: 'block',
    margin: '0',
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.2vw'
    },
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.3vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
        fontWeight: '600'
    }
}))

export const CompUser = styled('div')(({ theme }) => (props) => ({
    height: '50px',
    width: '80%',
    margin: " 10px 0px",
    borderRadius: theme.shape.borderRadius,
    border: 'solid 1px',
    borderColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: "center",
    justifyContent: 'space-evenly',
    [theme.breakpoints.down('md')]: {
        width: '50%',
        alignSelf: 'start'
    },
    [theme.breakpoints.down('xs')]: {
        width: '100%'
    }
}))

export const ImageUser = styled('div')(({ theme }) => (props) => ({
    height: '35px',
    width: '35px',
}))

export const UserImage = styled('img')(({ theme }) => (props) => ({
    height: '100%',
    width: '100%',
    borderRadius: '50%'
}))

export const UserText = styled('p')(({ theme }) => (props) => ({
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "20px",
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
}))

export const UserTextLight = styled('p')(({ theme }) => (props) => ({
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "20px",
    color: theme.palette.mode === "light" ? theme.palette.text.light : theme.palette.text.dark,
}))

export const LinkPart = styled(NavLink)(({ theme }) => (props) => ({
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "20px",
    width: '100%',
    padding: '10px',
    color: theme.palette.mode === "light" ? theme.palette.text.light : theme.palette.text.dark,
    textDecoration: 'none',
    overflowWrap: 'word-wrap'
}))

export const TitleDisc = styled("h3")(({ theme }) => (props) => ({
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "24px",
    width: '100%',
    padding: '10px',
    margin: '0',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
}))
export const PartDisc = styled("div")(({ theme }) => (props) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
}))
export const TitleInfo = styled("p")(({ theme }) => (props) => ({
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    width: '85%',
    padding: '10px',
    margin: '0',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
}))
export const DiscPart = styled("p")(({ theme }) => (props) => ({
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    width: '90%',
    padding: '10px',
    margin: '0',
    color: theme.palette.mode === "light" ? theme.palette.text.light : theme.palette.text.dark,
}))
export const VideoPart = styled("div")(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    flexDirection: 'column',
}))
export const VideoLink = styled(Link)(({ theme }) => (props) => ({
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "17px",
    width: '90%',
    padding: '10px',
    margin: '0',
    textDecoration: 'none',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    display: 'flex',
    alignItems: 'center',
    gap: "5px"
}))
export const ButtonLink = styled(ButtonBase)(({ theme }) => (props) => ({
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "17px",
    margin: '7px 0',
    width: '90%',
    textDecoration: 'none',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    gap: "5px"
}))
export const CusAccordion = styled(Accordion)(({ theme }) => (props) => ({
    width: '80%',
    [theme.breakpoints.down('md')]: {
        width: '50%'
    },
    [theme.breakpoints.down('xs')]: {
        width: '100%'
    }
}))
export const ContentFlex = styled("div")(({ theme }) => (props) => ({
    display: 'flex',
    padding: '10px',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: 'start'
    }
}))